export const isServiceSearchValid = (q?: string | null, categoryId?: number | null): boolean => {
  const isQValid = !!q;
  const isCategoryValid = categoryId !== undefined && categoryId !== null && !Number.isNaN(+categoryId);

  return isQValid || isCategoryValid;
};
